import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { HashRouter } from 'react-router-dom'
import { CssBaseline } from '@material-ui/core'
import JssProvider from 'react-jss/lib/JssProvider'
import { GlobalStyle, jss, generateClassName } from './utils/style-utils'
import { store } from './store'
import { PrimaryThemeProvider } from './styles'
import {
  Header,
  Redirector,
  Snackbar,
  ErrorBoundary,
  Overlay,
  CustomSnackbarProvider,
} from './components'
import { Router } from './Router'
import * as serviceWorker from './serviceWorker'
import { LocationTracker } from './utils/LocationTracker'
import * as analytics from './services/analytics'
import { API } from './config/api'
import { createHashHistory } from 'history'
export const history = createHashHistory()

if (API.GATRACKINGID) {
  analytics.init(history)
}

export const Root = () => (
  <Provider store={store}>
    <HashRouter>
      <JssProvider jss={jss} generateClassName={generateClassName}>
        <PrimaryThemeProvider>
          <GlobalStyle />
          <CssBaseline />
          <Header />
          <LocationTracker />
          <ErrorBoundary>
            <CustomSnackbarProvider>
              <Router />
              <Snackbar />
            </CustomSnackbarProvider>
            <Redirector />
            <Overlay />
          </ErrorBoundary>
        </PrimaryThemeProvider>
      </JssProvider>
    </HashRouter>
  </Provider>
)

ReactDOM.render(<Root />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
